// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : LAST EMI DETAILS TYPES CREATED
// MODIFIED DATE: 23-08-2025

const LastEMIDetailsActionTypes = {
	/** ***************** GET LAST EMI DETAILS DETAILS START *********************** */
	GET_LAST_EMI_DETAILS_START: 'get_last_emi_details_start',
	GET_LAST_EMI_DETAILS_SUCCESS: 'get_last_emi_details_success',
	GET_LAST_EMI_DETAILS_FAILURE: 'get_last_emi_details_failure',
	GET_LAST_EMI_DETAILS_RESPONSE_RESET: 'get_last_emi_details_response_reset',
	GET_LAST_EMI_DETAILS_RESPONSE_CHANGED: 'get_last_emi_details_response_changed',
	/** ***************** GET LAST EMI DETAILS DETAILS END *********************** */
};
export default LastEMIDetailsActionTypes;
